import { formatSharpCharts2DateString } from '@/utils/formatSharpCharts2DateString';
import { subtractMonths } from '@/utils/subtractMonths';
import { eraseHoursMinutesSecondsAndMilliseconds } from '@/utils/eraseHoursMinutesSecondsAndMilliseconds';

export function getDefaultSharpCharts2RangeStartDate() {
  const now = eraseHoursMinutesSecondsAndMilliseconds(new Date());
  const oneYearAgo = subtractMonths(now, 12, false);

  return formatSharpCharts2DateString(oneYearAgo);
}
